import React from 'react';
import { LineItemsBudget } from 'components';

export const LineItemBudgetPage = () => {
    return <LineItemsBudget />;
};
